import { render, staticRenderFns } from "./DeleteUserModal.vue?vue&type=template&id=5f22ed0e&"
import script from "./DeleteUserModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteUserModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports